var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('nav-com',{attrs:{"activeIndex":_vm.activeIndex,"bsenv":_vm.bsenv,"isLogin":_vm.isLogin,"userinfo":_vm.userinfo,"is-show-login":_vm.isShowLogin,"drop-list":_vm.dropList,"page-type":_vm.pageType,"child-page-type":_vm.childPageType,"custom-cart-count":_vm.customCartCount,"nav-list":_vm.navList,"transParent":_vm.immersive,"debugger":_vm.isDebugger,"isShowSlideBar":_vm.isShowSlideBar}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217c5d6e","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigator/entry.vue
// module id = 913
// module chunks = 1